/**
 * Users/AddExistingUser Controller
 *
 * 
 */

// the constructor for this object
function UsersAddExistingUserController() { }

// the object
UsersAddExistingUserController.prototype = {
    constructor: UsersAddExistingUserController,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        PortalHelper.debugMessage('Add Existing User Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // fill the accounts table
        this._populateTable();
        
        // enable the submit button
        PortalHelper.enableButton('#add-user');
        
        PortalHelper.debugMessage('Add Existing User Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function()
    {   
        var self = this;
        $('#add-existing-user-form').on('submit', function(e) {
            e.preventDefault();
            
            self._addUser();
        });
        
        // check all column event
        $('th.check-all-column').on('click', function() {
            var columnIndex = $(this).index();
            PortalMain.UsersAddExistingUserController._checkAllInColumn(columnIndex);
        });
    },
    
    /*
        Gathers field values from the form and makes a request to the API to 
        add a new portal user
    */    
    _addUser: function()
    {
        PortalHelper.loadingOverlay('#add-existing-user-form', true);
        var emailAddr = $('#email').val();
        
        /*
            Pulling each account and its access out of the form and putting it
            into an array
        */        
        var accountAccess = [];
        
        var formAccts = $('[data-account-id]');
        var hasAccess = false;
        
        formAccts.each(function(i, e){
            var accessLevel = $(this).find('input[type="radio"]:checked').val();
            accountAccess.push(
                {
                    account_id: $(this).attr('data-account-id'),
                    access_level: accessLevel,
                }
            );
            if(accessLevel != 0) {
                hasAccess = true;
            }
        });
        
        // break out of this function if the user hasn't added the user to at least one account
        if(!hasAccess) {
            $('.form-errors').html("This user must have access to at least one account.").removeClass('hidden');
            PortalHelper.loadingOverlay('#add-existing-user-form', false);
            return;
        }
        
        
        var addUserRequest = new PortalRequest();
        addUserRequest.successElement = '.form-success';
        addUserRequest.errorElement = '.form-errors';
        addUserRequest.makeRequest(
            '/users/add-existing-user',
            {
                email_nm: emailAddr,
                accounts: accountAccess
            },
            function(response) {
                PortalHelper.loadingOverlay('#add-existing-user-form', false);
                PortalHelper.disableButton('#add-user');
                
                setTimeout(function () {
                    window.location.href = PortalConfig.portalUrl + '/users/';
                }, 3000);
            },
            function(response) {
                PortalHelper.loadingOverlay('#add-existing-user-form', false);
            }
        )
    },
    
    /*
        Populates the Customer Accounts table with accounts that the user has
        administrator access to
    */
    _populateTable: function()
    {
        var portalUserAccounts = PortalMain.PortalAccounts.getAdminAccounts();
        /*
            If the user has no admin access to any customer accounts, they can't
            add users, so hide the whole form and display a message
        */
        if(portalUserAccounts.length == 0) {
            $('.form').html('Your account does not have permission to add new portal users.');
            PortalHelper.loadingOverlay('#add-existing-user-form', false);
            return;
        }
        /*
            Create rows for each account we have access to
        */
        for(var i in portalUserAccounts) {
            var currentAcct = portalUserAccounts[i];
            var newRow = $('#default-row').clone();
            var newRow = $('tr.clone-source').clone();
            newRow.removeClass('hidden').removeClass('clone-source');
            newRow.attr('data-account-id', currentAcct.account_id);
            newRow.find('input[type="radio"]').each(function(i, e) {
                $(e).attr('name', 'account-'+currentAcct.account_id);
            });
            newRow.find('.account-number').text(currentAcct.account_number);
            newRow.find('.account-name').text(currentAcct.name);
            $('table.accounts').append(newRow);
        }
        
        PortalHelper.loadingOverlay('#add-existing-user-form', false);
    },
    
    // check all inputs in the provided column index
    _checkAllInColumn: function(columnIndex)
    {
        $('table.accounts tbody tr:not(.clone-source) td').each(function() {
            var cellIndex = $(this).index();
            if (cellIndex == columnIndex) {
                $('input', this).prop('checked', true);
            }
        });
    },
    
}